import _ from "lodash";
import {Dispatch, SetStateAction} from "react";
import {
  ActionTypeEnum,
  BeneficiaryDetailLookUpResponseModel,
  ChangeItemValueTypeEnum,
  CompanySettingModel,
  CustomerResponseModel,
  DailyTransactionTypeEnum,
  ItemDiscountValuesModel,
  ItemSearchTypeEnum,
  ItemTotalValuesModel,
  LookupItemKeyValueModel,
  LookupItemModel,
  LookupKeyValueModel,
  LookupTypeEnum,
  ResponseBaseModel,
  RowStateEnum,
  StateGenericRequestModel,
  SupplierCustomerTypeEnum,
  TransactionClientConfigurationModel,
  TransactionDetailResponseModel,
  TransactionDiscountLevelTypeEnum,
  TransactionItemResponseModel,
  TransactionTotalValuesModel,
  UserConfigurationModel,
  UserSettingModel,
  UserTransactionsSettingResponseModel,
  ValidateTransactionModeEnum,
  ValidationErrorModel,
} from "../../../../models";
import {
  generateGuid,
  getLabelName,
  getOriginalValueInCurrency,
  getSystemLanguageId,
  getUserId,
  getUserStationId,
  getValueInCurrency, isArabicCurrentLanguage,
  roundNumber,
  secureLocalStorageGet,
  updateStateDynamically,
} from "../../../../utils";
import {SystemConfiguration} from "../../../../configuration";
import {getPointOfSaleSetting} from "../../../../serviceBroker/userApiServiceBroker";
import {getCurrentAccountBalance} from "../../../../serviceBroker/accountApiServiceBroker";
import {getLookupByType} from "../../../../serviceBroker/lookupApiServiceBroker";
import {
  calculateItemDiscount,
  calculateItemPrice,
  calculateItemTax,
  calculateItemUnitPriceOrPriceWithTax,
  getItemInStoreId,
  getItemSalesPrice,
} from "./commonBl";
import {getItemUnitBalanceByItemUnitID} from "../../../../serviceBroker/itemApiServiceBroker";
import {getTransactionAsSource, getTransactionDetail} from "../../../../serviceBroker/transactionApiServiceBroker";
import {
  getValidationChainByActionType,
  runSequentialValidations,
  validateTransactionEligibility,
} from "./validationBl";
import {getCurrentBalanceByCustomerId} from "../../../../serviceBroker/customerApiServiceBroker";
//#region variables
export const companySettingsInitialValues: CompanySettingModel = {
  Advert: undefined,
  ApplyTax: false,
  ArabicLanguage: "",
  AttachmentFolder: undefined,
  BacckGroundImage: "",
  BackColor: 0,
  BackGroundImageName: "",
  CalcDiscountWithVAT: false,
  CheckBalanceOfItemOnAdd: false,
  CompanyAddress: "",
  CompanySetting_UniqueId: "",
  Company_Address: "",
  CreatedBy: undefined,
  CreationDate: "",
  CurrencyShortCut: "",
  Currency_ID: 0,
  DateType: false,
  DaysOfDeleteBackupFiles: 0,
  DecimalPlace: 0,
  DefaultCurrency_ID: 0,
  DefaultTaxPercentage: 0,
  EnglishLanguage: "",
  Errors: [],
  FormatDate: "",
  FormatDecimal: "",
  Header: undefined,
  HideItemFromCloseDay: false,
  ID: 0,
  IncludeVatOnEditPrice: false,
  IsCodeTransactionSeparated: false,
  IsEnableToUploadEinvoice: false,
  IsFloorSecondeCurrency: false,
  IsSentEmailReportAfterCloseDayOnly: false,
  IsTrialVersion: false,
  IsUploadShipmentTrackToCloud: false,
  IsUploadTransactionToCloud: false,
  Is_Company_Authorized_Tobacco: false,
  LogoImage: "",
  LogoImage64: "",
  LogoImageName: "",
  Mail: "",
  MaxQuantity: 0,
  MobileReceiver: "",
  ModificationDate: "",
  ModifiedBy: undefined,
  Name: "",
  Password: "",
  PasswordSMS: "",
  PathBackUp: "",
  Phone: "",
  PrintItemArabicEngInBill: false,
  PrintItemPrescriptionOfTransaction: false,
  Printer_Tablet_List: "",
  RecivedMail: "",
  SendMailOfSalesOnClose: false,
  SendSMS: false,
  SenderName: "",
  ServiceUI: "",
  SetCostPriceZeroOnSalePriceZero: false,
  SetScaleOnPrice: false,
  SetScaleWeightonKG: false,
  ShowItemPriceWithoutTax: false,
  SoftwareName: undefined,
  SystemSettings: "",
  TaxNumber: "",
  TermsAndCondations: "",
  TextLogo: "",
  Token: undefined,
  TransferTaxToDiscount: false,
  UseOldModelForSearch: false,
  UserNameSMS: "",
  ValueOfCurrency: 0,
  ValueOfPoint: 0,
  VerifyOnUpdate: false,
  WaterMarkImage: "",
  rowState: 0,
  voucherSettings: undefined,
  isInitialRequest:true
};
export const userTransactionsSettingInitialValues: UserTransactionsSettingResponseModel =
  {
    DeafultNote: "",
    DefaultCalcTypeID: 0,
    DefaultPaymentTypeID: 0,
    DirectPrintBillAfterSave: false,
    EnableButonAdd: false,
    EnableDiscount: false,
    EnablePrint: false,
    EnableShangPrice: false,
    ID: 0,
    Name: null,
    NumberOfCopy: 0,
    PeriodAllowForReturn: 0,
    PrinterName: "",
    PrinterPrepairingSalesInvoice: "",
    RemarksVisable: "",
    ShowButtonPrintPrepairingOrder: false,
    ShowCalcType: false,
    ShowCinfirm: false,
    ShowCostCenter: false,
    ShowCurrency: false,
    ShowCustomerCar: false,
    ShowDone: false,
    ShowEmployeeResponsibile: false,
    ShowNotefy: false,
    ShowPaymentType: false,
    ShowPrice: false,
    ShowPrintStickerButton: false,
    ShowRefrence: false,
    ShowSaveAndPrintButton: false,
    ShowTransPortCost: false,
    TransactionType_ID: 0,
    User_ID: 0,
    VerifyOnUpdate: false,
    rowState: 0,
  };
export  const userSettingInitialValues: UserSettingModel = {
  AddItemInNewLineInBill: false,
  AlertOfCustomerDidintPaySince: 0,
  AllowItemPriceSaleLessThanCost: false,
  AllowSaleLessThanCost: false,
  AlowRepeateFactoItemUnit: false,
  CheckMaxDebitOfCustomer: false,
  CreatedBy: 0,
  CreationDate: new Date(),
  DaysAlertBeforeExpire: 0,
  EnableManualInvoiceCode: true,
  ID: 0,
  Lang: getSystemLanguageId(),
  MaxDiscountPercentage: 0,
  ModificationDate: new Date(),
  ModifiedBy: 0,
  Name: "",
  PeriodAllowToEdit: 0,
  ShowScaleBarcode: false,
  PreventStoreOutOfItemLessZero: false,
  PrintBarcodeAfterPurches: false,
  PrintItemPrescriptionAfterSale: false,
  RequestDueDateOnDelayPayment: false,
  RigesterBillOnPayment: false,
  SelectionEmployeeIsRequierd: false,
  ShowAlert: false,
  ShowBarcode: false,
  ShowItemModifiers: false,
  ShowMinimumPriceItem: false,
  ShowProfitOfBill: false,
  User_ID: getUserId(),
  VerifyOnUpdate: false,
  rowState: 1,
  isArabic: false,
  isEnglish: false,ShowHintOfItemCost: false,
};
export const transactionItemInitialValues: TransactionItemResponseModel = {
  Categ_ID: null,
  ItemInstore_ID: null,
  storeId: null,
  ItemUnit_ID: null,

  ItemDiscountRatio: 0,
  rowKey: "",

  TransactionHeader_ID: 0,
  TransDetail_IDParent: 0,
  ItemName: "",
  ItemName_En: "",
  ItemCode: "",
  Item_Modifiers_Json: "",
  Modifiers: undefined,
  Quantity: 1,
  defaultQuantity: 1,

  Unit_Price: 0,
  UnitPriceWithTaxCalculated: 0,
  Tax: 0,
  TotalTax: 0,
  ItemDiscount: 0,
  Total: 0,

  Unit_PriceInCurrencyCalculated: 0,
  UnitPriceWithTaxInCurrency: 0,
  TaxInCurrency: 0,
  TotalTaxInCurrency: 0,
  ItemDiscountInCurrency: 0,
  TotalInCurrency: 0,

  ValueOfCurrency: 1,
  // get  Unit_PriceComputed(): number {
  //   return  this.Unit_Price*10
  // },
  PriceCost: 0,
  Factor: 0,
  Transaction_Type: 0,

  MaxQty: 0,
  TaxPercentge: 0,

  IsGatherItem: false,
  UseExpiryDate: false,
  WithoutBalance: false,
  IsFromGatherItem: false,
  NotesDetails: "",
  Unit: "",
  UnitName: "",
  IsPrinted: false,
  ExpiryDate: "",
  ID: 0,
  CreatedBy: 0,
  ModifiedBy: 0,
  rowState: Number(RowStateEnum.Add),
  UnitBalance: 0,
  barCode: "",
  changeValueType: ChangeItemValueTypeEnum.None,
  latestModifiedDate: new Date(),
};
export const transactionDetailInitialValue = ():  TransactionDetailResponseModel => {
 return {
   Code: "",
   TransactionType: 0,
   CalcType_ID: null,
   InvoiceType: null,
   PaymentType_ID: null,
   Currency_ID: null,
   ValueCurrency: 1,
   Customer_ID: null,
   User_Update: 0,
   User_Create: getUserId(),
   Emp_ID: 0,
   Station_ID: getUserStationId(),
   Table_ID: 0,
   TempHeaderID: 0,
   Refrence: 0,
   IsPrinted: false,
   Date: new Date(),
   DueDate: new Date(new Date().setDate(new Date().getDate() + 1)),
   minDueDate: new Date(new Date().setDate(new Date().getDate() + 1)),
   discountRatio: 0,
   Discount: 0,
   TotalMony: 0,
   TotalTax: 0,
   TotalNet: 0,
   DiscountInCurrency: 0,
   TotalMonyInCurrency: 0,
   TotalTaxInCurrency: 0,
   TotalNetInCurrency: 0,

   MoneyAdd: 0,
   CashMoney: 0,
   CardMoney: 0,
   DelayMoney: 0,
   OthersMoney: 0,
   Tobacco_Value: 0,

   balance: 0,
   //isReInitializeTransactionValues:false,
   TransactionDetaillist: [],

   ID: 0,
   CreatedBy: getUserId(),
   ModifiedBy: 0,
   rowState: Number(RowStateEnum.Add),
   isReadyForInitialization: false,
   //discountLevelType:TransactionDiscountLevelTypeEnum.ItemLevel,
   //isTransactionDiscountEnabled:false,
   //isItemDiscountEnabled:true,
 }
};
export const customerInitialValue: CustomerResponseModel = {
  Code: 0,
  IDNumber: "",
  City_ID: 0,
  Address: "",
  Mobile: "",
  Phone: "",
  Mail: "",
  Notes: "",
  Cust_Type: Number(SupplierCustomerTypeEnum.Customer),
  Beg_AC_Bal: 0,
  AreaLand: "",
  User_ID: 0,
  Account_ID: 0,
  ISCustomerAndSupplier: false,
  PaymentTypeID: 0,
  Currency_ID: 0,
  ValueCurrency: 0,
  BalanceOfPoint: 0,
  IsDefault: false,
  MaxDebit: 0,
  Customer_UniqueID: 0,
  Name_En: "",
  TaxNumber: "",
  IsCopyToServer: true,
  Device_ID: 0,
  IsSponsor: false,
  Sponsor_Id: 0,
  IsActive: true,
  ProfitPercentage: 0,
  CustomerType: "",
  address: {
    CountryCode: "",
    FlatNumber: "",
    Governate: "",
    CreatedBy: 0,
    CreationDate: new Date(),
    ModificationDate: new Date(),
    CustomerId: 0,
    Address_GUID: "",
    ID: 0,
    ModifiedBy: 0,
    Name: "",
    RegionCity: "",
    Remarks: "",
    Row_State: 1,
    Street: "",
    VerifyOnUpdate: false,
    buildingNumber: "",
    rowState: 1,
  },
  IsCreateAccountOnSaveNewOne: false,
  IsSkipSaveAccount: false,
  ID: 0,
  CreatedBy: 0,
  ModifiedBy: 0,
  Name: "",
  ModificationDate: new Date(),
  VerifyOnUpdate: false,
  rowState: 1,
};
export const companySettingInitialValues: CompanySettingModel = {
  Advert: undefined,
  ApplyTax: false,
  ArabicLanguage: "",
  AttachmentFolder: undefined,
  BacckGroundImage: "",
  BackColor: 0,
  BackGroundImageName: "",
  CalcDiscountWithVAT: false,
  CheckBalanceOfItemOnAdd: false,
  CompanyAddress: "",
  CompanySetting_UniqueId: "",
  Company_Address: "",
  CreatedBy: undefined,
  CreationDate: "",
  CurrencyShortCut: "",
  Currency_ID: 0,
  DateType: false,
  DaysOfDeleteBackupFiles: 0,
  DecimalPlace: 0,
  DefaultCurrency_ID: 0,
  DefaultTaxPercentage: undefined,
  EnglishLanguage: "",
  Errors: [],
  FormatDate: "",
  FormatDecimal: "",
  Header: undefined,
  HideItemFromCloseDay: false,
  ID: 0,
  IncludeVatOnEditPrice: false,
  IsCodeTransactionSeparated: false,
  IsEnableToUploadEinvoice: false,
  IsFloorSecondeCurrency: false,
  IsSentEmailReportAfterCloseDayOnly: false,
  IsTrialVersion: false,
  IsUploadShipmentTrackToCloud: false,
  IsUploadTransactionToCloud: false,
  Is_Company_Authorized_Tobacco: false,
  LogoImage: "",
  LogoImage64: "",
  LogoImageName: "",
  Mail: "",
  MaxQuantity: undefined,
  MobileReceiver: "",
  ModificationDate: "",
  ModifiedBy: undefined,
  Name: "",
  Password: "",
  PasswordSMS: "",
  PathBackUp: "",
  Phone: "",
  PrintItemArabicEngInBill: false,
  PrintItemPrescriptionOfTransaction: false,
  Printer_Tablet_List: "",
  RecivedMail: "",
  SendMailOfSalesOnClose: false,
  SendSMS: false,
  SenderName: "",
  ServiceUI: "",
  SetCostPriceZeroOnSalePriceZero: false,
  SetScaleOnPrice: false,
  SetScaleWeightonKG: false,
  ShowItemPriceWithoutTax: false,
  SoftwareName: undefined,
  SystemSettings: "",
  TaxNumber: "",
  TermsAndCondations: "",
  TextLogo: "",
  Token: undefined,
  TransferTaxToDiscount: false,
  UseOldModelForSearch: false,
  UserNameSMS: "",
  ValueOfCurrency: 0,
  ValueOfPoint: 0,
  VerifyOnUpdate: false,
  WaterMarkImage: "",
  isInitialRequest: false,
  rowState: 0,
  voucherSettings: undefined
}
//#endregion
//#region user transactions settings functions
export const initializeTransactionValuesAndUserTransactionsConfiguration =
  async (
    setTransactionDetail: Dispatch<
      SetStateAction<TransactionDetailResponseModel>
    >,
    transactionDetail: TransactionDetailResponseModel,
    lookupList: LookupItemKeyValueModel[],
    currentTransactionSetting: UserTransactionsSettingResponseModel,
   // key:string
  ) => {
    const existingTransactionDetails = [...transactionDetail.TransactionDetaillist];
    const posSettingResult = await getPointOfSaleSetting(getUserId(),true);
    let customerId: number | null =posSettingResult.Customer_ID?? getLookupItemFirstDefaultValue(
      "customers",
      lookupList
    );

    const paymentTypeId: number | null = getLookupItemFirstDefaultValue(
      "payments",
      lookupList
    );
    const currencyId: number | null = getLookupItemFirstDefaultValue(
      "currencies",
      lookupList
    );
    const employeeId: number | null = getLookupItemFirstDefaultValue(
      "employees",
      lookupList
    );
    const calcTypeId: number | null = getLookupItemFirstDefaultValue(
      "calcTypes",
      lookupList
    );
    const costCenterId: number | null = getLookupItemFirstDefaultValue(
      "costCenters",
      lookupList
    );
    const currencyValueEntity: number = getCurrencyValueEntity(
      currencyId || 0,
      getLookupItemListFromDictionary("currencies", lookupList) || []
    );
    const customersList: LookupItemModel[] | null =
      getLookupItemListFromDictionary("customers", lookupList);

    customerId = customerId != null
        ? (Number(customersList?.find(p => Number(p.value) === customerId)?.value) || null)
        : null;

    const balance = await getAccountBalance(
      customerId !== null
        ? customerId
        : transactionDetail.Customer_ID != null
        ? transactionDetail.Customer_ID
        : 0,
      currencyId !== null
        ? currencyId
        : transactionDetail.Currency_ID != null
        ? transactionDetail.Currency_ID
        : null,
      customersList || []
    );
    setTransactionDetail(prevData => {
      const detailsToUse =
          prevData.TransactionDetaillist.length > 0
              ? prevData.TransactionDetaillist
              : existingTransactionDetails.length > 0
                  ? existingTransactionDetails
                  : [];
      return {
        ...prevData,
        Station_ID: -99,
        Customer_ID: customerId != null ? customerId : prevData.Customer_ID,
        Currency_ID: currencyId != null ? currencyId : prevData.Currency_ID,
        CostCenter_ID: costCenterId != null ? costCenterId : prevData.CostCenter_ID,
        Emp_ID: employeeId != null ? employeeId : prevData.Emp_ID,
        ValueCurrency: currencyValueEntity,
        PaymentType_ID: currentTransactionSetting.DefaultPaymentTypeID !== 0
            ? currentTransactionSetting.DefaultPaymentTypeID
            : paymentTypeId != null
                ? paymentTypeId
                : prevData.PaymentType_ID,
        CalcType_ID: currentTransactionSetting.DefaultCalcTypeID !== 0
            ? currentTransactionSetting.DefaultCalcTypeID
            : calcTypeId != null
                ? calcTypeId
                : prevData.CalcType_ID,
        balance: balance,
        TransactionDetaillist: detailsToUse,
      }});
    //setUserSettingStata({...currentTransactionSetting});
    // if (transactionSettingButtonRef.current) {
    //   transactionSettingButtonRef.current.click();
    // }
  }
//#endregion
//#region companySetting functions
export const getCompanySettings = (): CompanySettingModel => {
  try {
    const companySettingObj = secureLocalStorageGet(
      SystemConfiguration.cacheKey_Configurations.setting.companySettings
    );
    return companySettingObj !== null && companySettingObj !== undefined
      ? (JSON.parse(
            secureLocalStorageGet(
            SystemConfiguration.cacheKey_Configurations.setting.companySettings
          ) as string
        ) as CompanySettingModel)
      : companySettingsInitialValues;
  } catch (err) {
    return companySettingsInitialValues;
  }
};
//#endregion
//#region lookup functions
export const getLookUp = async (
  state: Dispatch<SetStateAction<any>>[],
  lookup: LookupTypeEnum,
  isCached: boolean = true,
  addEmptySelect: boolean = false
): Promise<LookupItemModel[]> => {
  const lookupList = await getLookupByType(lookup, isCached, addEmptySelect);
  state.forEach((setStateRow) => {
    setStateRow(lookupList);
  });
  return lookupList;
};
export const getLookUpWithStateUpdateForResultOfSingleRow = async (
  state: Dispatch<SetStateAction<any>>[],
  lookup: LookupTypeEnum,
  updateState: StateGenericRequestModel[],
  isCached: boolean = true,
  addEmptySelect: boolean = false
): Promise<LookupItemModel[]> => {
  const lookupList = await getLookupByType(lookup, isCached, addEmptySelect);
  state.forEach((setStateRow) => {
    setStateRow(lookupList);
  });
  if (
    lookupList.length === 1 &&
    updateState !== null &&
    updateState !== undefined &&
    updateState.length !== 0
  ) {
    const value: any = lookupList[0].value;
    updateState.forEach((setStaterow) => {
      if (
        setStaterow.filed !== null &&
        setStaterow.filed !== undefined &&
        setStaterow.filed !== ""
      ) {
        updateStateDynamically(
          setStaterow.state,
          setStaterow.value,
          setStaterow.filed,
          value
        );
      }
    });
  }
  return lookupList;
};
//#endregion
//#region calculation functions
export const handleChangeNewRecordItemCalculation = async (
    request: TransactionItemResponseModel,
    transactionRequest: TransactionDetailResponseModel,
    userTransactionSetting: UserTransactionsSettingResponseModel,
    transactionType: DailyTransactionTypeEnum,
    itemList: LookupItemModel[],
    calcTypeList: LookupItemModel[]
):Promise<TransactionItemResponseModel> => {
  //const itemObject = itemList.find(p => p.otherValue.itemUnitId === request.ItemUnit_ID);
  const itemInStoreId: number | null = getItemInStoreId(
      Number(request.ItemUnit_ID),
      itemList
  );
  const balance = await getItemUnitBalanceByItemUnitID(request.ItemUnit_ID??0);
  const itemSalePrice: number =
      itemInStoreId !== null
          ? getItemSalesPrice(
              Number(request.ItemUnit_ID || 0),
              transactionType,
              transactionRequest.CalcType_ID !== null &&
              transactionRequest.CalcType_ID !== undefined
                  ? transactionRequest.CalcType_ID
                  : null,
              itemList,
              calcTypeList,
              userTransactionSetting
          )
          : 0;
  const itemPriceCalculatedValues = handleCalculateNewItemValuesChange(
      itemList,
      Number(request.ItemUnit_ID || 0),
      itemSalePrice,
      transactionRequest.ValueCurrency,
      true,
      false
  );
  const discountCalculatedValues = handleCalculateNewItemDiscountValuesChange(
      request.ItemDiscount,
      transactionRequest.ValueCurrency,
      false
  );
  const itemTaxPercentage =
      itemInStoreId !== null
          ? getItemTaxPercentageValue(Number(request.ItemUnit_ID || 0), itemList)
          : 0;
  request.ItemInstore_ID = itemInStoreId;
  request.TaxPercentge = itemTaxPercentage;
  request.TaxPercentge = itemTaxPercentage;
  request.Unit_Price = itemPriceCalculatedValues.UnitPrice;
  request.UnitPriceWithTaxCalculated =
      itemPriceCalculatedValues.UnitPriceWithTax;
  request.Unit_PriceInCurrencyCalculated =
      itemPriceCalculatedValues.UnitPriceInCurrency;
  request.UnitPriceWithTaxInCurrency =
      itemPriceCalculatedValues.UnitPriceWithTaxInCurrency;
  request.ItemDiscount = discountCalculatedValues.ItemDiscount;
  request.ItemDiscountInCurrency =
      discountCalculatedValues.ItemDiscountInCurrency;
  request.UnitBalance = balance ?? 0;
  return request;
};
export const handleTransactionTotalValues = (
  request: TransactionDetailResponseModel
): TransactionDetailResponseModel => {
  let totalValuesResponse: TransactionTotalValuesModel = {
    totalMoney: 0,
    totalTax: 0,
    totalDiscount: 0,
    totalNet: 0,
    totalMoneyInCurrency: 0,
    totalTaxInCurrency: 0,
    totalDiscountInCurrency: 0,
    totalNetInCurrency: 0,
    totalDiscountPercentage: 0,
  };
  let transportCost: number = 0;
  let moneyAdd: number = 0;
  let tobaccoValue: number = 0;
  let totalAdditionalCostValue: number = 0;
  if (
    request!= null &&
    request?.TransactionDetaillist?.length != 0
  ) {
    request.TransactionDetaillist.filter(
      (p) => p.rowState !== RowStateEnum.Delete
    ).forEach((row) => {
      const rowMoney: number = row.Unit_Price * row.Quantity;
      const rowTax = row.Tax * row.Quantity;
      totalValuesResponse.totalMoney = roundNumber(
        totalValuesResponse.totalMoney + rowMoney
      );
      totalValuesResponse.totalTax = roundNumber(
        totalValuesResponse.totalTax + rowTax
      );
      totalValuesResponse.totalDiscount = roundNumber(
        totalValuesResponse.totalDiscount + row.ItemDiscount
      );

      totalValuesResponse.totalMoneyInCurrency =
        totalValuesResponse.totalMoneyInCurrency +
        getValueInCurrency(rowMoney, row.ValueOfCurrency);
      totalValuesResponse.totalTaxInCurrency =
        totalValuesResponse.totalTaxInCurrency +
        getValueInCurrency(rowTax, row.ValueOfCurrency);
      totalValuesResponse.totalDiscountInCurrency =
        totalValuesResponse.totalDiscountInCurrency +
        getValueInCurrency(row.ItemDiscount, row.ValueOfCurrency);
    });
    totalValuesResponse.totalDiscountPercentage =
      totalValuesResponse.totalDiscount === 0
        ? 0
        : roundNumber(
            (totalValuesResponse.totalDiscount /
              totalValuesResponse.totalMoney) *
              100
          );

    totalValuesResponse.totalNet = roundNumber(
      totalValuesResponse.totalMoney -
        totalValuesResponse.totalDiscount +
        transportCost +
        moneyAdd +
        totalValuesResponse.totalTax +
        tobaccoValue +
        totalAdditionalCostValue
    );
    totalValuesResponse.totalNetInCurrency = roundNumber(
      totalValuesResponse.totalMoneyInCurrency -
        totalValuesResponse.totalDiscountInCurrency +
        transportCost +
        moneyAdd +
        totalValuesResponse.totalTaxInCurrency +
        tobaccoValue +
        totalAdditionalCostValue
    );
  }
  request.TotalMony = roundNumber(totalValuesResponse.totalMoney);
  request.TotalMonyInCurrency = roundNumber(
    totalValuesResponse.totalMoneyInCurrency
  );
  request.TotalNet = roundNumber(totalValuesResponse.totalNet);
  request.TotalNetInCurrency = roundNumber(
    totalValuesResponse.totalNetInCurrency
  );
  request.TotalTax = roundNumber(totalValuesResponse.totalTax);
  request.TotalTaxInCurrency = roundNumber(
    totalValuesResponse.totalTaxInCurrency
  );
  request.Discount = roundNumber(totalValuesResponse.totalDiscount);
  request.DiscountInCurrency = roundNumber(
    totalValuesResponse.totalDiscountInCurrency
  );
  request.discountRatio = roundNumber(
    totalValuesResponse.totalDiscountPercentage
  );
  return request;
};
export const handleTransactionTotalValuesByTransactionItems = (
  request: TransactionItemResponseModel[]
): TransactionTotalValuesModel => {
  let response: TransactionTotalValuesModel = {
    totalMoney: 0,
    totalTax: 0,
    totalDiscount: 0,
    totalNet: 0,
    totalMoneyInCurrency: 0,
    totalTaxInCurrency: 0,
    totalDiscountInCurrency: 0,
    totalNetInCurrency: 0,
    totalDiscountPercentage: 0,
  };
  let transportCost: number = 0;
  let moneyAdd: number = 0;
  let tobaccoValue: number = 0;
  let totalAdditionalCostValue: number = 0;
  if (request !== null && request !== undefined && request.length !== 0) {
    request
      .filter((p) => p.rowState !== RowStateEnum.Delete)
      .forEach((row) => {
        const rowMoney: number = row.Unit_Price * row.Quantity;
        const rowTax = row.Tax * row.Quantity;
        response.totalMoney = roundNumber(response.totalMoney + rowMoney);
        response.totalTax = roundNumber(response.totalTax + rowTax);
        response.totalDiscount = roundNumber(
          response.totalDiscount + row.ItemDiscount
        );

        response.totalMoneyInCurrency =
          response.totalMoneyInCurrency +
          getValueInCurrency(rowMoney, row.ValueOfCurrency);
        response.totalTaxInCurrency =
          response.totalTaxInCurrency +
          getValueInCurrency(rowTax, row.ValueOfCurrency);
        response.totalDiscountInCurrency =
          response.totalDiscountInCurrency +
          getValueInCurrency(row.ItemDiscount, row.ValueOfCurrency);
      });

    response.totalDiscountPercentage =
      response.totalDiscount === 0
        ? 0
        : roundNumber((response.totalDiscount / response.totalMoney) * 100);

    response.totalNet = roundNumber(
      response.totalMoney -
        response.totalDiscount +
        transportCost +
        moneyAdd +
        response.totalTax +
        tobaccoValue +
        totalAdditionalCostValue
    );
    response.totalNetInCurrency = roundNumber(
      response.totalMoneyInCurrency -
        response.totalDiscountInCurrency +
        transportCost +
        moneyAdd +
        response.totalTaxInCurrency +
        tobaccoValue +
        totalAdditionalCostValue
    );
  }
  return response;
};
export const updateTransactionItemsCurrencyValueAndReCalculateAllValues = (
  request: TransactionItemResponseModel[],
  currencyValue: number
): TransactionItemResponseModel[] => {
  let result: TransactionItemResponseModel[] = [];
  if (request !== null && request !== undefined && request.length !== 0) {
    result = _.map(request, (row) => {
      if (row.rowState !== RowStateEnum.Delete) {
        row.ValueOfCurrency = currencyValue;
        row.changeValueType = ChangeItemValueTypeEnum.ChangePrice;
        const record = handleCalculateItemRecordValuesUpdate(row);
        return { ...record, changeValueType: ChangeItemValueTypeEnum.None };
      } else {
        return row;
      }
    });
  }
  return result;
};
export const handleCalculateNewItemValuesChange = (
  itemList: LookupItemModel[],
  itemId: number,
  value: number,
  currencyValueEntity: number,
  isTaxCalculation: boolean,
  isCalculateInCurrencyValue: boolean
): ItemTotalValuesModel => {
  let response: ItemTotalValuesModel = {
    UnitPrice: 0,
    UnitPriceInCurrency: 0,
    UnitPriceWithTax: 0,
    UnitPriceWithTaxInCurrency: 0,
  };
  if (itemId !== 0) {
    const itemTaxPercentage: number = getItemTaxPercentage(itemId, itemList);
    const calculatedValue: number = calculateItemUnitPriceOrPriceWithTax(
      value,
      itemTaxPercentage,
      isTaxCalculation
    );
    if (isCalculateInCurrencyValue) {
      response.UnitPriceInCurrency = isTaxCalculation ? value : calculatedValue;
      response.UnitPriceWithTaxInCurrency = isTaxCalculation
        ? calculatedValue
        : value;
      response.UnitPrice = getOriginalValueInCurrency(
        response.UnitPriceInCurrency,
        currencyValueEntity
      );
      response.UnitPriceWithTax = getOriginalValueInCurrency(
        response.UnitPriceWithTaxInCurrency,
        currencyValueEntity
      );
    } else {
      response.UnitPrice = isTaxCalculation ? value : calculatedValue;
      response.UnitPriceWithTax = isTaxCalculation ? calculatedValue : value;
      response.UnitPriceInCurrency = getValueInCurrency(
        response.UnitPrice,
        currencyValueEntity
      );
      response.UnitPriceWithTaxInCurrency = getValueInCurrency(
        response.UnitPriceWithTax,
        currencyValueEntity
      );
    }
  }
  return response;
};
export const handleCalculateItemRecordValuesUpdate = (
  request: TransactionItemResponseModel
): TransactionItemResponseModel => {
  switch (request.changeValueType) {
    case ChangeItemValueTypeEnum.ChangePrice:
      request.UnitPriceWithTaxCalculated = calculateItemUnitPriceOrPriceWithTax(
        request.Unit_Price,
        request.TaxPercentge,
        true
      );
      break;
    case ChangeItemValueTypeEnum.ChangePriceInCurrency:
      request.UnitPriceWithTaxInCurrency = calculateItemUnitPriceOrPriceWithTax(
        request.Unit_PriceInCurrencyCalculated,
        request.TaxPercentge,
        true
      );
      break;
    case ChangeItemValueTypeEnum.ChangePriceWithTax:
      request.Unit_Price = calculateItemUnitPriceOrPriceWithTax(
        request.UnitPriceWithTaxCalculated,
        request.TaxPercentge,
        false
      );
      break;
    case ChangeItemValueTypeEnum.ChangePriceWithTaxInCurrency:
      request.Unit_PriceInCurrencyCalculated =
        calculateItemUnitPriceOrPriceWithTax(
          request.UnitPriceWithTaxInCurrency,
          request.TaxPercentge,
          false
        );
      break;
    case ChangeItemValueTypeEnum.ChangeDiscount:
      request.ItemDiscountInCurrency = getValueInCurrency(
        request.ItemDiscount,
        request.ValueOfCurrency
      );
      break;
    case ChangeItemValueTypeEnum.ChangeDiscountInCurrency:
      request.ItemDiscount = getOriginalValueInCurrency(
        request.ItemDiscountInCurrency,
        request.ValueOfCurrency
      );
      break;
    case ChangeItemValueTypeEnum.All:
      break;
  }
  switch (request.changeValueType) {
    case ChangeItemValueTypeEnum.ChangePrice:
    case ChangeItemValueTypeEnum.ChangePriceWithTax:
      request.ItemDiscountInCurrency = getValueInCurrency(
        request.ItemDiscount,
        request.ValueOfCurrency
      );
      request.Unit_PriceInCurrencyCalculated = getValueInCurrency(
        request.Unit_Price,
        request.ValueOfCurrency
      );
      request.UnitPriceWithTaxInCurrency = getValueInCurrency(
        request.UnitPriceWithTaxCalculated,
        request.ValueOfCurrency
      );
      break;
    case ChangeItemValueTypeEnum.ChangePriceInCurrency:
    case ChangeItemValueTypeEnum.ChangePriceWithTaxInCurrency:
      request.ItemDiscount = getOriginalValueInCurrency(
        request.ItemDiscountInCurrency,
        request.ValueOfCurrency
      );
      request.Unit_Price = getOriginalValueInCurrency(
        request.Unit_PriceInCurrencyCalculated,
        request.ValueOfCurrency
      );
      request.UnitPriceWithTaxCalculated = getOriginalValueInCurrency(
        request.UnitPriceWithTaxInCurrency,
        request.ValueOfCurrency
      );
      break;
  }

  request.Tax = calculateItemTax(request);
  request.TotalTax = request.Tax * request.Quantity;
  request.Total = calculateItemPrice(request);
  request.TaxInCurrency = getValueInCurrency(
    request.Tax,
    request.ValueOfCurrency
  );
  request.TotalTaxInCurrency = getValueInCurrency(
    request.TotalTax,
    request.ValueOfCurrency
  );
  request.TotalInCurrency = getValueInCurrency(
    request.Total,
    request.ValueOfCurrency
  );
  return { ...request };
};
export const handleCalculateNewItemDiscountValuesChange = (
  value: number,
  currencyValueEntity: number,
  isCalculateInCurrencyValue: boolean
): ItemDiscountValuesModel => {
  let response: ItemDiscountValuesModel = {
    ItemDiscount: 0,
    ItemDiscountInCurrency: 0,
  };
  response.ItemDiscount = isCalculateInCurrencyValue
    ? getOriginalValueInCurrency(value, currencyValueEntity)
    : value;
  response.ItemDiscountInCurrency = isCalculateInCurrencyValue
    ? value
    : getValueInCurrency(value, currencyValueEntity);
  return response;
};
export const handleChangeTransactionDiscountRatio = async (
  setState: Dispatch<SetStateAction<TransactionDetailResponseModel>>,
  stateValue: TransactionDetailResponseModel
  // value:number
) => {
  let obj = stateValue.TransactionDetaillist;
  obj = _.map(obj, (row) => {
    row.ItemDiscountRatio = stateValue.discountRatio;

    if (stateValue.discountRatio !== 0) {
      const calculatedDiscount = calculateItemDiscount(row);
      row.ItemDiscount = calculatedDiscount.ItemDiscount;
      row.ItemDiscountInCurrency = calculatedDiscount.ItemDiscountInCurrency;
    } else {
      row.ItemDiscount = 0;
      row.ItemDiscountInCurrency = 0;
    }
    row.Total = calculateItemPrice(row);
    row.TotalInCurrency = getValueInCurrency(row.Total, row.ValueOfCurrency);
    return row;
  });
  const stateObject = handleTransactionTotalValues({
    ...stateValue,
    TransactionDetaillist: obj,
  });
  setState({
    ...stateObject,
    //discountRatio: value,
    TransactionDetaillist: obj,
  });
};
export const handleChangeTransactionDiscount = async (
  setState: Dispatch<SetStateAction<TransactionDetailResponseModel>>,
  stateValue: TransactionDetailResponseModel
  //value:number
) => {
  let obj = stateValue.TransactionDetaillist;
  const itemDiscountValueInCurrency = roundNumber(
    stateValue.DiscountInCurrency / obj.length
  );
  obj = _.map(obj, (row) => {
    row.ItemDiscountInCurrency = itemDiscountValueInCurrency;
    row.ItemDiscount = getOriginalValueInCurrency(
      itemDiscountValueInCurrency,
      row.ValueOfCurrency
    );
    row.Total = calculateItemPrice(row);
    row.TotalInCurrency = getValueInCurrency(row.Total, row.ValueOfCurrency);
    return row;
  });
  const stateObject = handleTransactionTotalValues({
    ...stateValue,
    TransactionDetaillist: obj,
  });
  setState({
    ...stateObject,
    TransactionDetaillist: obj,
  });
};
export const handleUpdateExistingTransactionValues = (
  request: TransactionItemResponseModel
) => {
  //request.UnitPriceWithTax=calculateItemUnitPriceOrPriceWithTax(request.Unit_Price,request.TaxPercentge,true);
  //request.Tax=calculateItemTax(request);
  //request.TotalTax=request.Tax*request.Quantity;
  //request.Total = calculateItemPrice(request);
  request.Unit_PriceInCurrencyCalculated = getValueInCurrency(
    request.Unit_Price,
    request.ValueOfCurrency
  );
  request.UnitPriceWithTaxInCurrency = getValueInCurrency(
    request.UnitPriceWithTaxCalculated,
    request.ValueOfCurrency
  );
  request.ItemDiscountInCurrency = getValueInCurrency(
    request.ItemDiscount,
    request.ValueOfCurrency
  );
  request.TaxInCurrency = getValueInCurrency(
    request.Tax,
    request.ValueOfCurrency
  );
  request.TotalTaxInCurrency = getValueInCurrency(
    request.TotalTax,
    request.ValueOfCurrency
  );
  request.TotalInCurrency = getValueInCurrency(
    request.Total,
    request.ValueOfCurrency
  );
  request.rowKey = generateGuid();
  return { ...request };
};
export const getItemTaxPercentageValue = (
  id: number,
  itemList: LookupItemModel[]
): number => {
  const item = itemList.filter(
    //@ts-ignore
    (p) => p.value === id.toString()
  )[0];
  return item != null &&
    item.otherValue !== null &&
    item.otherValue !== undefined
    ? item.otherValue.taxPercentage
    : 0;
};
//#endregion
//#region post functions
export const addItem = async (
  request: TransactionItemResponseModel,
  data: TransactionDetailResponseModel,
  itemList: LookupItemModel[],
  userConfiguration: UserConfigurationModel
): Promise<TransactionItemResponseModel> => {
  try {
    let index = _.findIndex(data.TransactionDetaillist, {
      ItemUnit_ID: request.ItemUnit_ID,
    });
    index= userConfiguration?.userSetting?.AddItemInNewLineInBill? -1:index;
    if (index !== -1) {
      const newItem = request;
      request = data.TransactionDetaillist[index];
      request.Quantity = Number(request.Quantity) + Number(newItem.Quantity);
      request.Unit_Price = newItem.Unit_Price;
      request.Unit_PriceInCurrencyCalculated =
        newItem.Unit_PriceInCurrencyCalculated;
      request.ItemDiscount =
        newItem.ItemDiscount !== 0
          ? newItem.ItemDiscount
          : request.ItemDiscount;
      request.ItemDiscountInCurrency =
        newItem.ItemDiscountInCurrency !== 0
          ? newItem.ItemDiscountInCurrency
          : request.ItemDiscountInCurrency;
    }
    request.ItemInstore_ID =
      request.ItemInstore_ID === null || request.ItemInstore_ID === undefined
        ? 0
        : request.ItemInstore_ID;

    const item = itemList.filter(
      //@ts-ignore
      (p) => p.value === request.ItemUnit_ID.toString()
    )[0];
    if (item !== null && item !== undefined) {
      request.ValueOfCurrency = data.ValueCurrency;
      request.ItemName = item.nameAr;
      request.ItemName_En = item.name;
      request.ItemCode = item.otherValue.code;
      request.Categ_ID =
        item.otherValue?.categoryId !== null
          ? Number(item.otherValue.categoryId)
          : null;
      request.UnitBalance =
        item.otherValue?.balance !== null
          ? Number(item.otherValue.balance)
          : null;
      request.TaxPercentge =
        item.otherValue?.taxPercentage !== null
          ? Number(item.otherValue.taxPercentage)
          : 0;
      request.CreatedBy = request.ID === 0 ? getUserId() : request.CreatedBy;
      request.ModifiedBy = request.ID !== 0 ? getUserId() : request.ModifiedBy;
      request.Factor = item.otherValue.factor;

      request.ItemDiscountInCurrency = request.ItemDiscountInCurrency || 0;
      request.ItemDiscount = request.ItemDiscount || 0;
      request.ItemDiscountRatio = request.ItemDiscountRatio || 0; //(data.discountRatio || 0);
      const calculatedDiscount: ItemDiscountValuesModel =
        calculateItemDiscount(request);
      request.ItemDiscount = calculatedDiscount.ItemDiscount; // calculateItemDiscount(request);
      request.ItemDiscountInCurrency =
        calculatedDiscount.ItemDiscountInCurrency;

      request.Unit_PriceInCurrencyCalculated = getValueInCurrency(
        request.Unit_Price,
        data.ValueCurrency
      );
      request.UnitPriceWithTaxCalculated = calculateItemUnitPriceOrPriceWithTax(
        request.Unit_Price,
        request.TaxPercentge,
        true
      );
      request.UnitPriceWithTaxInCurrency = getValueInCurrency(
        request.UnitPriceWithTaxCalculated,
        data.ValueCurrency
      );
      request.Tax = calculateItemTax(request);
      request.TaxInCurrency = getValueInCurrency(
        request.Tax,
        data.ValueCurrency
      );
      request.TotalTax = request.Tax * request.Quantity;
      request.TotalTaxInCurrency = getValueInCurrency(
        request.TotalTax,
        data.ValueCurrency
      );
      request.Total = calculateItemPrice(request);
      request.TotalInCurrency = getValueInCurrency(
        request.Total,
        data.ValueCurrency
      );
    }
    request.rowKey = generateGuid();
  } catch (e) {}
  //@ts-ignore
  return request;
};
export const handleDeleteItem = async (
  setState: Dispatch<SetStateAction<TransactionDetailResponseModel>>,
  stateValue: TransactionDetailResponseModel,
  deleteItem: TransactionItemResponseModel
) => {
  const itemsList = await deleteItemRow(
    deleteItem,
    stateValue.TransactionDetaillist
  );

  const stateObject = handleTransactionTotalValues({
    ...stateValue,
    TransactionDetaillist: itemsList,
  });

  setState({
    ...stateObject,
    TransactionDetaillist: itemsList,
  });

  // setState({
  //   ...stateValue,
  //   TransactionDetaillist: result,
  // });
};
export const deleteItemRow = async (
  deleteItem: TransactionItemResponseModel,
  data: TransactionItemResponseModel[]
): Promise<TransactionItemResponseModel[]> => {
  if (deleteItem !== null && deleteItem !== undefined) {
    if (deleteItem.ID === 0) {
      data = _.filter(data, (row) => {
        return row.rowKey !== deleteItem.rowKey;
      });
    } else {
      data = _.map(data, (row) => {
        if (row.ID === deleteItem.ID) {
          return { ...row, rowState: Number(RowStateEnum.Delete) };
        } else {
          return row;
        }
      });
    }
  }
  return data;
};
//#endregion
//#region State functions
export const UpdateTransactionDetailDataBasedOnUserSetting = (
  request: TransactionDetailResponseModel,
  setting: UserTransactionsSettingResponseModel,
  setState: Dispatch<SetStateAction<TransactionDetailResponseModel>>
) => {
  let count: number = 0;
  if (
    (request.PaymentType_ID == null ) &&
    !setting.ShowPaymentType  &&
    setting.DefaultPaymentTypeID != null
  ) {
    request.PaymentType_ID = setting.DefaultPaymentTypeID;
    count++;
  }

  if (
    (request.CalcType_ID == null) &&
    !setting.ShowCalcType &&
    setting.DefaultCalcTypeID != null
  ) {
    request.CalcType_ID = setting.DefaultCalcTypeID;
    count++;
  }

  if (count > 0) {
    setState(request);
  }
};
export const updateStateDynamicallyFromLookupList = async (
  list: LookupItemModel[],
  setState: Dispatch<SetStateAction<any>>,
  stateValue: any,
  key?: string | null
) => {
  if (list !== null && list !== undefined && list.length != 0) {
    await updateStateDynamically(
      setState,
      stateValue,
      key,
      list[0].value,
      null
    );
  }
};
//#endregion
//#region customer functions
export const getAccountBalance = async (
  id: number,
  currencyId: number | null,
  list: LookupItemModel[]
): Promise<number> => {
  try {
    if (id !== 0) {
      const accountId: number | null = list.filter(
        (p) => p.value == id.toString()
      )[0].otherValue.accountId;
      return await getCurrentAccountBalance(accountId || 0, currencyId);
    }
  } catch (err) {}
  return 0;
};
//#endregion
//#region items & categories functions
export const addDefaultStore =  ({
                                        transactionItemObject,
                                        storeList
                                      }: {
  transactionItemObject: TransactionItemResponseModel;
  storeList: LookupItemModel[];
}): TransactionItemResponseModel => ({
  ...transactionItemObject,
  storeId: Number(storeList?.[0]?.value) || 0
});
export const handleSearchAndFilterBeneficiary=async ({setState,stateList,originalStateList, beneficiaryType=SupplierCustomerTypeEnum.Customer, searchValue=null}:{
  setState: Dispatch<SetStateAction<LookupItemModel[]>>;
  stateList: LookupItemModel[];
  originalStateList: LookupItemModel[];
  beneficiaryType:SupplierCustomerTypeEnum;
  searchValue?: string | null;
})=> {

  if (!searchValue) {
    setState(originalStateList);
    return;
  }

  const searchTerm = searchValue.toLowerCase();
  const filteredList = stateList.filter(item => {
    const nameMatch = isArabicCurrentLanguage()
        ? item.nameAr?.toLowerCase().includes(searchTerm)
        : item.name?.toLowerCase().includes(searchTerm);
    const mobileMatch = (item.otherValue as BeneficiaryDetailLookUpResponseModel)?.mobile?.toLowerCase().includes(searchTerm);
    return nameMatch || mobileMatch;
  });
  if (filteredList.length > 0) {
    setState(filteredList);
    return;
  }
  const data = await getLookupByType(LookupTypeEnum.Customers, false, false, [
      {key:"custmertype",value:beneficiaryType.toString()},
      {key:"name",value:searchTerm},
    {key:"mobile",value:searchTerm},
  ]);
  setState(data);
  return;
};
export const handleSearchAndFilterItems = async ({
                                                   setItemsState,
                                                   setItemsPerCategoryState,
                                                   setTransactionItemObjectState,
                                                   itemList,
                                                   itemPerCategoryList,
                                                   calcTypeList,
                                                   isArabic,
                                                   transactionDetailObject,
                                                   transactionItemObject,
                                                   userSetting,
                                                   transactionConfiguration,
                                                   searchType=ItemSearchTypeEnum.default,
                                                   searchValue = null,
                                                 }: {
  setItemsState: Dispatch<SetStateAction<LookupItemModel[]>>;
  setItemsPerCategoryState: Dispatch<SetStateAction<LookupItemModel[]>>;
  setTransactionItemObjectState: Dispatch<SetStateAction<TransactionItemResponseModel>>,
  itemList: LookupItemModel[];
  itemPerCategoryList: LookupItemModel[];
  calcTypeList: LookupItemModel[],
  transactionDetailObject: TransactionDetailResponseModel;
  transactionItemObject: TransactionItemResponseModel;
  userSetting: UserConfigurationModel,
  transactionConfiguration: TransactionClientConfigurationModel,
  isArabic: boolean;
  searchType: ItemSearchTypeEnum;
  searchValue?: string | null;
}) => {
  if(transactionItemObject.storeId==null) {
    setItemsPerCategoryState([]);
    return;
  }
  // // Single store logic
  // if (transactionConfiguration.hasSingleStore && itemList && itemList.length !== 0) {
  //
  //   const itemsPerCategoryList: LookupItemModel[] =
  //      transactionItemObject.Categ_ID !=null
  //           ? itemList.filter(
  //               (p) =>
  //                   p.value !== null && p.otherValue.categoryId === Number( transactionItemObject.Categ_ID)
  //           )
  //           : itemList;
  //   setItemsPerCategoryState(itemsPerCategoryList);
  //   return; // Skip the rest of the logic for single store case
  // }
  // Normal search logic
  const  { resultList, isFetchedFromDb } = await handleSearchItemsOrFetchFromDb({
    itemList: itemList!=null && itemList.length!=0?itemList: itemPerCategoryList ?? [],
    searchType:searchType,
    searchValue:searchValue,
    storeId:transactionItemObject.storeId,
    categoryId:transactionItemObject.Categ_ID,
    isArabic:isArabic});
  if (isFetchedFromDb && resultList && resultList.length !== 0) {
      const concatenatedItemsList: LookupItemModel[] =searchType===ItemSearchTypeEnum.none||searchType===ItemSearchTypeEnum.default?resultList:itemList.concat(resultList);
      const concatenatedItemsPerCategoryList: LookupItemModel[] =searchType===ItemSearchTypeEnum.none||searchType===ItemSearchTypeEnum.default?resultList:itemPerCategoryList.concat(resultList);
      setItemsState(concatenatedItemsList);
      setItemsPerCategoryState(concatenatedItemsPerCategoryList);
    }
  if (searchType==ItemSearchTypeEnum.barcode ) {
    if (resultList && resultList.length !== 0) {
      const transactionItemObj =await handleChangeNewRecordItemCalculation(
          {
            ...transactionItemObject,
            ItemUnit_ID: Number(resultList[0].otherValue.itemUnitId),
          },
          transactionDetailObject!,
          userSetting?.userTransactionSetting!,
          transactionConfiguration?.transactionType!,
          itemList.concat(resultList), // Concatenated list
          calcTypeList!
      );
      transactionItemObj.barCode = searchValue!;
      setTransactionItemObjectState!(transactionItemObj);
    } else {
      transactionItemObject!.barCode = searchValue!;
      setTransactionItemObjectState!(transactionItemObject!);
    }
  }
};
export const getItemTaxPercentage = (
  value: number | null,
  itemList: LookupItemModel[]
): number => {
  if (value !== null && value !== undefined && value != 0) {
    const item = itemList.filter(
      //@ts-ignore
      (p) => p.value === value.toString()
    )[0];
    return item !== null &&
      item !== undefined &&
      item.otherValue != null &&
      item.otherValue.taxPercentage !== null
      ? Number(item.otherValue.taxPercentage)
      : 0;
  }
  return 0;
};
//#endregion
//#region user functions
export const UpdateTransactionActionUser = (
  request: TransactionDetailResponseModel
): TransactionDetailResponseModel => {
  request.Station_ID =
    request.Station_ID == 0 ||
    request.Station_ID == null
      ? getUserStationId()
      : request.Station_ID;
  request.CreatedBy =
    request.rowState === Number(RowStateEnum.Add) &&
    (request.CreatedBy == 0 ||
      request.CreatedBy == null )
      ? getUserId()
      : request.CreatedBy;
  request.User_Create =
    request.rowState === Number(RowStateEnum.Add) &&
    (request.User_Create == 0 ||
      request.User_Create == null )
      ? getUserId()
      : request.User_Create;
  request.ModifiedBy =
    request.rowState === Number(RowStateEnum.Update) &&
    (request.ModifiedBy == 0 ||
      request.ModifiedBy == null )
      ? getUserId()
      : request.ModifiedBy;
  request.User_Update =
    request.rowState === Number(RowStateEnum.Update) &&
    (request.User_Update == 0 ||
      request.User_Update == null )
      ? getUserId()
      : request.User_Update;
  return request;
};
//#endregion
//#region currency functions
export const getCurrencyValueEntity = (
  currencyId: number,
  currencyList: LookupItemModel[]
): number => {
  if (currencyId !== 0 && currencyList !== null && currencyList !== undefined) {
    const currencyObject = currencyList.filter(
      (p) => p.value === currencyId.toString()
    )[0];
    if (
      currencyObject !== null &&
      currencyObject !== undefined &&
      currencyObject.otherValue !== null &&
      currencyObject.otherValue !== undefined &&
      currencyObject.otherValue.ValueEntity !== null &&
      currencyObject.otherValue.ValueEntity !== undefined
    ) {
      return currencyObject.otherValue.ValueEntity || 1;
    }
  }
  return 1;
};
//#endregion
//#region control editable functions
export const handleTransactionDiscountEditable = (
  isSettingDiscountEnabled: boolean,
  discountLevelType: TransactionDiscountLevelTypeEnum
): boolean => {
  return (
    isSettingDiscountEnabled &&
    discountLevelType === TransactionDiscountLevelTypeEnum.TransactionLevel
  );
};
export const handleItemDiscountEditable = (
  isSettingDiscountEnabled: boolean,
  discountLevelType: TransactionDiscountLevelTypeEnum
): boolean => {
  return (
    isSettingDiscountEnabled &&
    discountLevelType === TransactionDiscountLevelTypeEnum.ItemLevel
  );
};
export const isDiscountControlEditable = (
  isSettingDiscountEnabled: boolean,
  isDiscountEnabled: boolean
): boolean => {
  return isSettingDiscountEnabled ? isDiscountEnabled : false;
};
//#endregion
//#region textBox
export const getTextBoxNumericOrDefaultValue = (e: any): number => {
  return e !== null &&
    e.target !== null &&
    e.target.value !== null &&
    e.target.value !== ""
    ? e.target.value
    : 0;
};
export const getTextBoxValue = (e: any): string | null => {
  return e !== null &&
    e.target !== null &&
    e.target.value !== null &&
    e.target.value !== ""
    ? e.target.value
    : null;
};
//#endregion
//#region transactions refund
export const isRefundTransaction = (
  transactionType: DailyTransactionTypeEnum
): boolean => {
  const refundableTransactionTypes = [
    DailyTransactionTypeEnum.SalesRefund,
    DailyTransactionTypeEnum.PurchasesRefund,
    DailyTransactionTypeEnum.POSSalesRefund,
  ];
  return refundableTransactionTypes.includes(transactionType);
};
export const clearTransactionDataForRefund = async (
    request: TransactionDetailResponseModel
):Promise< TransactionDetailResponseModel >=> {
  if (request !== null) {
    let stores = await getLookupByType(LookupTypeEnum.Stores, true, false);
    stores = stores ?? [];
    const _hasSingleStore = stores.length <= 1;

    request.Code = "";
    request.Date = new Date();
    request.TransactionType = getRefundTransactionType(request.TransactionType);
    request.User_Create = getUserId();
    request.User_Update = getUserId();
    // request.Refrence = request.ID;
    request.rowState = RowStateEnum.Add;
    //request.ID = 0;
    if (
        request.TransactionDetaillist !== null &&
        request.TransactionDetaillist.length !== 0
    ) {
      request.TransactionDetaillist.forEach((row) => {
        row.rowKey = generateGuid();
        row.storeId= Number(stores[0]?.value);
        row.rowState = RowStateEnum.None;
        row.Transaction_Type=request.TransactionType;
        row.ID = 0;
      });
    }
    request.defaultStoreId =  _hasSingleStore ? Number(stores[0]?.value) : null;
  }
  return request;
};
export const clearTransactionDataForReSell = async (
    request: TransactionDetailResponseModel
):Promise< TransactionDetailResponseModel >=> {
  if (request !== null) {
    let stores = await getLookupByType(LookupTypeEnum.Stores, true, false);
    stores = stores ?? [];
    const _hasSingleStore = stores.length <= 1;

    request.Code = "";
    request.TransactionType = DailyTransactionTypeEnum.SalesInvoice;
    request.User_Create = request.User_Create??getUserId();
    request.User_Update =  request.User_Update??getUserId();
    request.rowState = RowStateEnum.Add;
    if (
        request.TransactionDetaillist !== null &&
        request.TransactionDetaillist.length !== 0
    ) {
      request.TransactionDetaillist.forEach((row) => {
        row.rowKey = generateGuid();
        row.storeId= Number(stores[0]?.value);
        row.rowState = RowStateEnum.None;
        row.Transaction_Type=request.TransactionType;
        row.ID = 0;
      });
    }
    request.defaultStoreId =  _hasSingleStore ? Number(stores[0]?.value) : null;
    request.Date=new Date();
  }
  return request;
};
export const handleRefundTransactionItemSelectStatus = (
  items: TransactionItemResponseModel[],
  rowKey: string | null,
  checked: boolean
): TransactionItemResponseModel[] => {
  if (items !== null && items.length !== 0) {
    return items.map((row) => {
      if (rowKey !== null && row.rowKey === rowKey) {
        return {
          ...row,
          rowState: checked ? RowStateEnum.Add : RowStateEnum.Update,
        };
      } else if (rowKey === null) {
        return {
          ...row,
          rowState: checked ? RowStateEnum.Add : RowStateEnum.Update,
        };
      }
      return row;
    });
  }
  return items;
};
//#endregion
//#region prepare Request
export const prepareAndValidateTransactionAsSourceRequest  = async ({
                                                                        transactionId,
                                                                        transactionType,
                                                                        actionType,
                                                                      }: {
  transactionId: number;
  transactionType: DailyTransactionTypeEnum;
  actionType: ActionTypeEnum;
}):Promise<[TransactionDetailResponseModel | null, ValidationErrorModel[]]> => {
  let apiRecord: ResponseBaseModel<TransactionDetailResponseModel>|null=null;
  switch (actionType){
    case ActionTypeEnum.IssueSaleTransactionFromSalePrice:
      apiRecord = await getTransactionAsSource(transactionId);
      break;
    default:
      apiRecord= await getTransactionDetail(transactionId);
      break;
  }
  let record:TransactionDetailResponseModel | null=apiRecord?.Result??null;
  let errors:ValidationErrorModel[]=apiRecord?.Errors??[];
  // const errorsValidation = await runSequentialValidations([
  //   () => Promise.resolve(validateTransactionNotFoundError(record)),
  //   () => validateGetTransactionAsSourceDetails(record),
  // ]);
  const errorsValidation = await runSequentialValidations(
      getValidationChainByActionType( record,transactionType,actionType)
  );
    errors.push(...errorsValidation);
  // errors.push(...await validateGetTransactionAsSourceDetails(record));
  if(errors?.length == 0) {
    if (record) {
      record.isReadyForInitialization = true;
      record.rowKey=generateGuid();
    }
    switch (actionType) {
      case ActionTypeEnum.Update:
      case ActionTypeEnum.ModifyStart:
        //return await handleUpdateOrModifyStart(response, beneficiaryList);
        // Add other action types as needed
      case ActionTypeEnum.IssueSaleTransactionFromSalePrice:
        initializeTransactionData(record, actionType);
        record = await clearTransactionDataForReSell(record || transactionDetailInitialValue());
        record = await updateTransactionItemsDetail(record);
        record = await updateTransactionBalanceAndTotalValues(record);
        break;
      default:
        //return response;
    }
  }
  return  [record,errors];
}
// export const prepareAndValidateRequest = async ({
//                                                   transactionId,
//                                                   transactionType,
//                                                   actionType,
//                                                   beneficiaryList,
//                                                 }: {
//   transactionId: number;
//   transactionType: DailyTransactionTypeEnum;
//   actionType: ActionTypeEnum;
//   beneficiaryList:LookupItemModel[];
// }): Promise<ResponseBaseModel<TransactionDetailResponseModel>> => {
//   let response: ResponseBaseModel<TransactionDetailResponseModel> = await getTransactionDetail(transactionId);
//   const rowState = getRowState(actionType);
//   const transactionNotFoundErrors=validateTransactionNotFoundError(response?.Result!);
//   if(transactionNotFoundErrors!=null && transactionNotFoundErrors.length!=0){
//
//   }
//   if (!isTransactionFound(response)) {
//     return addTransactionNotFoundError(response);
//   }
//   initializeTransactionData(response, actionType);
//
//   switch (actionType) {
//     case ActionTypeEnum.Update:
//     case ActionTypeEnum.ModifyStart:
//       return await handleUpdateOrModifyStart(response, beneficiaryList);
//       // Add other action types as needed
//     default:
//       return response;
//   }
// }
//#endregion
//#region private
const isTransactionFound = (response: ResponseBaseModel<TransactionDetailResponseModel>): boolean => {
  return response?.Result != null;
};
const addTransactionNotFoundError = (response: ResponseBaseModel<TransactionDetailResponseModel>): ResponseBaseModel<TransactionDetailResponseModel> => {
  response.Errors = response.Errors ?? [];
  response.Errors.push({
    MessageAr: getLabelName("Transaction not found"),
    MessageEn: getLabelName("Transaction not found"),
  });
  return response;
};
const initializeTransactionData = (
    response: TransactionDetailResponseModel|null,
    actionType: ActionTypeEnum
): void => {
  if (!response) return;
  const rowState = getRowState(actionType);
  response.minDueDate = response.DueDate;
  response.rowState = rowState;
  response.TransactionDetaillist.forEach((row) => {
    row.rowState = rowState;
    row.rowKey = generateGuid();
  });
};
const handleUpdateOrModifyStart = async (
    response: ResponseBaseModel<TransactionDetailResponseModel>,
    beneficiaryList: LookupItemModel[]
): Promise<ResponseBaseModel<TransactionDetailResponseModel>> => {
  // Ensure Result is not null
  if (!response.Result) return response;

  // Validate transaction eligibility
  const eligibilityErrors = await validateTransactionEligibility({
    transactionId: response.Result.ID,
    creationDate: response.Result.Date,
    totalTax: response.Result.TotalTax,
    mode: ValidateTransactionModeEnum.Modify
  });

  if (eligibilityErrors?.length !== 0) {
    return addEligibilityErrors(response, eligibilityErrors);
  }

  // Update existing transaction values
  updateTransactionDetailItems(response);

  // Get account balance and update transaction total values
  return await updateBalanceAndTotalValues(response, beneficiaryList);
};
const addEligibilityErrors = (
    response: ResponseBaseModel<TransactionDetailResponseModel>,
    errors: any[]
): ResponseBaseModel<TransactionDetailResponseModel> => {
  response.Errors = response.Errors ?? [];
  response.Errors.push(...errors);
  return response;
};
const updateTransactionDetailItems = (
    response: ResponseBaseModel<TransactionDetailResponseModel>
): void => {
  if (!response.Result) return;

  (response.Result.TransactionDetaillist as TransactionItemResponseModel[]).forEach((row) => {
    row = handleUpdateExistingTransactionValues(row);
    return {...row};
  });
};
const updateTransactionItemsDetail = async(
    response: TransactionDetailResponseModel | null
): Promise<TransactionDetailResponseModel | null> => {
  if (!response || !response.TransactionDetaillist) return response;

  response.TransactionDetaillist = response.TransactionDetaillist.map((row) =>
      handleUpdateExistingTransactionValues(row)
  );

  return response;
};

const updateTransactionBalanceAndTotalValues = async (
    request: TransactionDetailResponseModel|null
): Promise<TransactionDetailResponseModel|null> => {
  if (!request) return request;
  const balance: number = await getCurrentBalanceByCustomerId(request?.Customer_ID??0,request?.Currency_ID??0);
  const dataObject = handleTransactionTotalValues(request);
  return  { ...dataObject, balance: balance };
};

const updateBalanceAndTotalValues = async (
    response: ResponseBaseModel<TransactionDetailResponseModel>,
    beneficiaryList: LookupItemModel[]
): Promise<ResponseBaseModel<TransactionDetailResponseModel>> => {
  if (!response.Result) return response;

  const balance: number = await getAccountBalance(
      response.Result.Customer_ID != null ? response.Result.Customer_ID : 0,
      response.Result.Currency_ID != null ? response.Result.Currency_ID : null,
      beneficiaryList
  );

  const dataObject = handleTransactionTotalValues(response.Result);
  response.Result = { ...dataObject, balance: balance };

  return response;
};

const isUpdateAction = (actionType: ActionTypeEnum): boolean => {
  const updateActionTypes = [ActionTypeEnum.Update, ActionTypeEnum.ModifyStart];
  return updateActionTypes.includes(actionType);
};
const isAddAction = (actionType: ActionTypeEnum): boolean => {
  const addActionTypes = [ActionTypeEnum.Add];
  return addActionTypes.includes(actionType);
};
const getRowState = (actionType: ActionTypeEnum): RowStateEnum => {
  if (isUpdateAction(actionType)) {
    return RowStateEnum.Update;
  }
  if (isAddAction(actionType)) {
    return RowStateEnum.Add;
  }
  return RowStateEnum.View;
};
export const handleSearchItemsOrFetchFromDb = async ({
                                                       itemList,
                                                       searchType,
                                                       isArabic,
                                                       storeId = null,
                                                       categoryId = null,
                                                       searchValue = null,
                                                     }: {
  itemList: LookupItemModel[];
  searchType: ItemSearchTypeEnum;
  isArabic: boolean;
  storeId?: number | null;
  categoryId?: number | null;
  searchValue?: string | null;
}): Promise<{ resultList: LookupItemModel[]; isFetchedFromDb: boolean }> => {
  let resultList: LookupItemModel[] = [];
  let isFetchedFromDb = false;
  const value = searchValue?.toLowerCase()?.trim() ?? "";
  if (storeId || categoryId || !value || searchType === null) {
    const filters: LookupKeyValueModel[] = [];
    if (storeId) {filters.push({ key: "searchItem.store_ID", value: storeId.toString() });}
    if (categoryId) {filters.push({ key: "searchItem.categorey_ID", value: categoryId.toString() });}
    if (value && searchType) {filters.push({ key: "searchItem.mixFilitrationNameAndCode", value });}
    resultList = await getLookupByType(LookupTypeEnum.Items, false, false, filters);
    isFetchedFromDb = true;
    return { resultList, isFetchedFromDb };
  }
  if (value.length < 3 && searchType != ItemSearchTypeEnum.nameAndBarcode) {
    return { resultList, isFetchedFromDb };
  }
  const applyFilters = (items: LookupItemModel[]) => {
    if (searchType === ItemSearchTypeEnum.barcode) {return items.filter(row => row.otherValue?.barCode?.includes(value));}
    if (searchType === ItemSearchTypeEnum.name) {
      return items.filter(row =>
          isArabic
              ? row.nameAr?.toLowerCase()?.includes(value)
              : row.name?.toLowerCase()?.includes(value)
      );
    }
    // For 'both' type
    return items.filter(row =>
        row.otherValue?.barCode?.includes(value) ||
        (isArabic
            ? row.nameAr?.toLowerCase()?.includes(value)
            : row.name?.toLowerCase()?.includes(value))
    );
  };
  resultList = applyFilters(itemList);
  if (resultList.length === 0) {
    const filters: LookupKeyValueModel[] = [
      { key: "searchItem.mixFilitrationNameAndCode", value }
    ];
    resultList = await getLookupByType(LookupTypeEnum.Items, false, false, filters);
    isFetchedFromDb = true;
  }

  return { resultList, isFetchedFromDb };
};

const getLookupItemListFromDictionary = (
  key: string,
  lookupList: LookupItemKeyValueModel[] | null
): LookupItemModel[] | null => {
  const list: LookupItemKeyValueModel | null =
    lookupList !== null && lookupList !== undefined && lookupList.length !== 0
      ? lookupList.filter((p) => p.key.toLowerCase().trim() === key)[0]
      : null;
  return list !== null &&
    list !== undefined &&
    list.value !== null &&
    list.value !== undefined &&
    list.value.length !== 0
    ? list.value
    : null;
};
const getLookupItemFirstDefaultValue = (
  key: string,
  lookupList: LookupItemKeyValueModel[] | null
): number | null => {
  const list: LookupItemKeyValueModel | null =
    lookupList !== null && lookupList !== undefined && lookupList.length !== 0
      ? lookupList.filter(
          (p) => p.key.toLowerCase().trim() === key.toLowerCase().trim()
        )[0]
      : null;
  return list !== null &&
    list !== undefined &&
    list.value !== null &&
    list.value !== undefined &&
    list.value.length !== 0
    ? Number(list.value.filter((p) => p.value !== null)[0].value)
    : null;
};
const getRefundTransactionType = (transactionType: number): number => {
  switch (transactionType) {
    case DailyTransactionTypeEnum.SalesInvoice:
    case DailyTransactionTypeEnum.SalesRefund:
    case DailyTransactionTypeEnum.POSSales:
    case DailyTransactionTypeEnum.POSSalesRefund:
    case DailyTransactionTypeEnum.POSRestaurant:
    case DailyTransactionTypeEnum.Reserve_Restaurant_Bill:
    case DailyTransactionTypeEnum.ReturnPOSRestaurant:
      transactionType = Number(DailyTransactionTypeEnum.SalesRefund);
      break;
    case DailyTransactionTypeEnum.PurchasesInvoice:
      transactionType = Number(DailyTransactionTypeEnum.PurchasesRefund);
      break;
  }

  return transactionType;
};
//#endregion
